<template>
    <div class="bg-red">
        <div class="activity-wrapper">
            <!--5.填寫表單-->
            <div class="frame step5"
            v-if="currentStep === 5">
                <div class="explain-wrapper">
                    <img src="@/assets/form_toothpaste.png" class="img" alt="牙膏">
                    <p class="subtitle">
                        請留下資料並公開分享《開運笑起來》結果至個人FB或LINE動態牆，
                        即有機會獲得 <strong>酵素潔護牙膏</strong> 及 <strong>酵素亮白牙膏</strong> 各一支(恕不挑選口味)
                    </p>
                </div>
                <div class="form-wrapper">
                    <div class="form-group">
                        <label class="label control-label col-12">
                        姓名
                        </label>
                        <div class="col-12">
                            <input type="text" class="form-control"
                            v-model="personalData.name"
                            name="personalData.name"
                            v-validate="'required'">
                            <span class="required-text"
                            v-show="errors.has('personalData.name') && !pageData.isFirstEdit"
                            >請填寫姓名</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="label control-label col-12">
                        電話
                        </label>
                        <div class="col-12">
                            <input type="tel" class="form-control"
                            v-model="personalData.phone"
                            name="personalData.phone"
                            v-validate="'required'">
                            <span class="required-text"
                            v-show="errors.has('personalData.phone') && !pageData.isFirstEdit"
                            >請填寫電話</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="label control-label col-12">
                        Email
                        </label>
                        <div class="col-12">
                            <input type="email" class="form-control"
                            v-model="personalData.email"
                            name="personalData.email"
                            v-validate="'required|email'">
                            <span class="required-text"
                            v-show="errors.has('personalData.email') && !pageData.isFirstEdit"
                            >請填寫Email或輸入正確Email</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="label control-label col-12">
                        地址
                        </label>
                        <div class="col-12 select-wrapper">
                            <div class="row">
                                <div class="col-6">
                                    <select class="form-control"
                                    v-model="personalData.county_id"
                                    @change="updateDistricts"
                                    name="personalData.county_id"
                                    v-validate="'required'">
                                        <option
                                        v-for="c in countys"
                                        :key="c.county_id"
                                        :value="c.county_id"
                                        v-text="c.name"
                                        ></option>
                                    </select>
                                </div>
                                <div class="col-6">
                                    <select class="form-control"
                                    v-model="personalData.district_id"
                                    name="personalData.district_id"
                                    v-validate="'required'">
                                        <option
                                        v-for="d in districts"
                                        :key="d.district_id"
                                        :value="d.district_id"
                                        v-text="d.name"
                                        ></option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <input type="text" class="form-control"
                            v-model="personalData.address"
                            name="personalData.address"
                            v-validate="'required'">
                            <span class="required-text"
                            v-show="(errors.has('personalData.county_id')
                            || errors.has('personalData.district_id')
                            || errors.has('personalData.address'))
                            && !pageData.isFirstEdit"
                            >請填寫地址</span>
                        </div>
                    </div>

                    <div class="note-wrapper">
                        <div class="col-12">
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input type="checkbox" class="form-check-input"
                                    v-model="isAgree">
                                    我已瞭解並同意
                                    <a href="" @click.prevent="openNewWindow('Law');
                                    gaEvent(gaCategory, 'privacy');">個資條款</a> 及
                                    <a href="" @click.prevent="openNewWindow('Info');
                                    gaEvent(gaCategory, 'activity');">活動辦法</a>
                                </label>
                            </div>
                            <p>
                                ※  請務必留下正確有效資料、中文全名
                            </p>
                        </div>
                    </div>
                </div>
                <div class="btn-wrapper">
                    <button type="button"
                    class="btn btn-circle btn-yellow btn-sm"
                    @click="onSubmit(); gaEvent(gaCategory, 'form_send');">
                    確認送出
                    </button>
                </div>
            </div>
            <!--/5.填寫表單-->
        </div>
    </div>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';
import apiUrl from '@/api/all';

export default {
    name: 'ActivityForm',
    data() {
        return {
            gaCategory: 'test_btn',
            urls: apiUrl,
            // 目前步驟頁 5.填寫表單
            currentStep: 5,
            // 縣市列表
            countys: [],
            // 地區列表
            districts: [
                {
                    district_id: null,
                    name: '請選擇地區',
                },
            ],
            // 表單資料
            personalData: {
                guid: '',
                county_id: null,
                district_id: null,
                name: '',
                phone: '',
                email: '',
                address: '',
                from: null,
            },
            // 是否同意
            isAgree: false,
        };
    },
    mounted() {
        this.initData();

        // 取得縣市資料
        this.getOptions(this.urls.getCounty, 'countys', 'county_id', '請選擇縣市');
    },
    methods: {
        // 初始化資料，取得笑容類別
        initData() {
            if (!this.$route.params.id) {
                this.goPage('Home', 'Index');
                return;
            }
            this.personalData.guid = this.$route.params.id;
            // eslint-disable-next-line
            // debugger;
            this.personalData.from = this.$route.query.from;
        },
        // 取得下拉選單項目
        getOptions(url, targetName, codeName, defaultVal) {
            const defaultObj = {};
            defaultObj[codeName] = null;
            defaultObj.name = defaultVal;

            this.$http.get(url).then((ret) => {
                if (ret.data && ret.data.message) {
                    this[targetName] = ret.data.message;
                }
                this[targetName].unshift(defaultObj);
            });
        },
        // 更新地區下拉選單
        updateDistricts(e) {
            const counyId = parseInt(e.target.value, 10);
            const defaultObj = {
                district_id: null,
                name: '請選擇地區',
            };
            this.personalData.district_id = '';
            if (Number.isNaN(counyId)) {
                this.districts = [defaultObj];
                return;
            }

            this.getOptions(this.urls.getDistrict + counyId, 'districts', 'district_id', defaultObj.name);
        },
        // 表單驗證
        onSubmit() {
            // this.personalData.guid = this.result.guid;
            if (!this.isAgree) {
                this.commonAlert('請勾選同意個資條款及活動辦法喔！');
                return;
            }
            this.validateForm(this.submit);
        },
        // 表單送出
        submit() {
            const vm = this;
            this.setLoading(true);
            this.$http.post(this.urls.createUserInfo, this.personalData).then((ret) => {
                if (ret.data.status === 1) {
                    this.commonAlert('恭喜成功送出報名資料！', vm.goProductPage);
                } else {
                    this.commonAlert(ret.data.message);
                }
                this.setLoading(false);
            }, this.errorHandler);
        },
        // 前往產品頁
        goProductPage() {
            this.goPage('Product');
        },
        // 開新視窗
        openNewWindow(routeName) {
            const routeData = this.$router.resolve({ name: routeName });
            window.open(routeData.href, '_blank');
        },
    },
    mixins: [mixinMethod],
    components: {
    },
    watch: {
        '$route.params.id': {
            handler() {
                this.initData();
            },
            deep: true,
            immediate: true,
        },
    },
};

</script>
